<template>
  <section
    :class="{ 'slide-up': revealIcon, 'slide-out': !revealIcon,'product-icon-reveal': !isWall, 'product-icon-reveal-touchscreen': isWall }"
    :style="{
      top: productIcon.position.top + '%',
      left: productIcon.position.left + '%',
      transitionDelay: productIcon.delay + 's'
    }"
  >
    <img class="product-icon-reveal__img" :src="getIcon(productIcon.icon)" alt />
  </section>
</template>

<script>
export default {
  name: "product-icon-reveal",
  props: ["productIcon", "revealIcon"],
  data() {
    return {
      isWall: process.env.VUE_APP_IS_BROWSER === "false"
    };
  },
  methods: {
    getIcon(pic) {
      if (pic) {
        var image = require.context("@/assets/product-bar-assets/", false);
        return image("./" + pic);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.product-icon-reveal {
  will-change: auto;
  position: absolute;
  width: 1.2vw;
  height: 1.2vw;
  min-width: 40px;
  min-height: 40px;
  @media only screen and (max-width: 420px) {
    min-width: 30px;
    min-height: 30px;
  }
  &__img {
    width: 100%;
    height: 100%;
  }
}
.product-icon-reveal-touchscreen {
  will-change: auto;
  position: absolute;
  width: 1vw;
  height: 1vw;
  &__img {
    width: 100%;
    height: 100%;
  }
}
.slide-up {
  transition: opacity $transition-duration,
    transform $transition-duration cubic-bezier(0.64, 0.03, 0.07, 1.8);
  opacity: 1;
  transform: translateY(0%);
}
.slide-out {
  opacity: 0;
  transform: translateY(100%);
  transition: opacity $transition-duration,
    transform $transition-duration ease-in-out;
  transition-delay: 0s !important;
}
</style>
